import React from "react";

export default function BottomNav({ onScrollToCategories }) {
  const handleSpecialOrderClick = () => {
    window.location.href = "https://beyzadebaklava.de/";
  };

  return (
    <nav className="nav">
      <button
        className="active"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <span className="nav-icon">🏠</span>
        <span>Start</span>
      </button>
      <button onClick={onScrollToCategories}>
        <span className="nav-icon">📖</span>
        <span>Karte</span>
      </button>
      <button onClick={handleSpecialOrderClick}>
        <span className="nav-icon">🎁</span>
        <span>Sonderbestellung</span>
      </button>
    </nav>
  );
}
